import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: [],
  singleQuizDetail: null,
  subjectsList: []
}

export const quizDetailsSlice = createSlice({
  name: 'quiz-details',
  initialState,
  reducers: {
    getSingleQuizDetails: (state, action) => {
      state.data = action.payload;
    },
    getQuizDetailsSubjectsList: (state, action) => {
      state.subjectsList = action.payload
    },
    resetQuizDetail: (state) => {
      state.data = [];
      state.singleQuizDetail = null
      state.subjectsList = []
    }
  },
})

// Action creators are generated for each case reducer function
export const { resetQuizDetail, getSingleQuizDetails, getQuizDetailsSubjectsList } = quizDetailsSlice.actions

export default quizDetailsSlice.reducer;